import type { QuoteArea } from 'paintscout'
import { parseNumber } from '../util/parse-number'
export function calculateCuft(area: QuoteArea) {
  const length = parseNumber(area.dimensions && area.dimensions.length ? area.dimensions.length : 0)
  const width = parseNumber(area.dimensions && area.dimensions.width ? area.dimensions.width : 0)
  const height = parseNumber(area.dimensions && area.dimensions.height ? area.dimensions.height : 0)

  return length * width * height
}
